import React from 'react'

import { Header } from '../../components/Header'
import { BannerSearch } from '../../components/BannerSearch'
import { BannerRegisterSitter } from '../../components/BannerRegisterSitter'
import { MostVisitedSitters } from '../../components/MostVisitedSitters'
import { HowWorksIt } from '../../components/HowWorksIt'
import { Blog } from '../../components/Blog'
import { Footer } from '../../components/Footer'

export const Home = () => {
    return (
        <>
            <Header />        
            <BannerSearch />
            <MostVisitedSitters />
            <HowWorksIt />
            <BannerRegisterSitter />
            <Blog />
            <Footer />
        </>
    )
}